import { render, staticRenderFns } from "./DocumentTypeToolbar.vue?vue&type=template&id=6fcac2de&scoped=true"
import script from "./DocumentTypeToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentTypeToolbar.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeToolbar.vue?vue&type=style&index=0&id=6fcac2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcac2de",
  null
  
)

export default component.exports